// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/federmechanismen/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const federmechanismenDE: PageEntry = {
  id: "post.federmechanismen",
  locale: "de",
  slug: "federmechanismen",
  seo: {
    title: "Glossar: Federmechanismen einfach erklärt | Dietz GmbH",
    description: "Federmechanismen beschreiben die verschiedenen Arten und Anwendungen von Federn in technischen Systemen. Es gibt verschiedene Federmechanismen, darunter Druckfedern, Zugfedern, Tor",
  },
  type: "post",
  h1: "Glossar: Federmechanismen einfach erklärt",
  intro: "Federmechanismen beschreiben die verschiedenen Arten und Anwendungen von Federn in technischen Systemen. Es gibt verschiedene Federmechanismen, darunter Druckfedern, Zugfedern, Torsionsfedern und Blattfedern. Jeder Mechanismus hat spezifische Eigenschaften, die für bestimmte Anwendungen geeignet sind. Druckfedern werden beispielsweise in Fahrwerken eingesetzt, während Zugfedern in Schließmechanismen verwendet werden. Das Verständnis der verschiedenen Federmechanismen ermöglicht es Ingenieuren, die am besten geeignete Feder für die jeweilige Anwendung auszuwählen und zu konstruieren.",
  blocks: [

  ],
};
